import {CacheKey, Deserializer, JsonIgnore, JsonProperty, ObjectMapper, Serializer} from "json-object-mapper";
import {Channel} from "./channels.model";
import {DataEntry} from "./fields.model";

export class MonitoringTransaction {
  @JsonProperty({name: "ts"})
  public ts?: number = undefined;

  @JsonProperty({name: "record"})
  public record?: number = undefined;

  @JsonProperty({name: "labels"})
  public labels?: number = undefined;

  @JsonProperty({name: "values"})
  public values?: Record<string, string | number | boolean> = undefined;

}

@CacheKey("ArrayMonitoringTransactionSerializerDeserializer")
export class ArrayMonitoringTransactionSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): MonitoringTransaction[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(MonitoringTransaction, v);
    })
  }
  serialize = (values: MonitoringTransaction[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class MonitoringHit {
  @JsonProperty({name: "reference"})
  public reference?: string = undefined;

  @JsonProperty({name: "info"})
  public info?: string = undefined;

  @JsonProperty({name: "score"})
  public score?: number = undefined;

}

@CacheKey("ArrayMonitoringHitSerializerDeserializer")
export class ArrayMonitoringHitSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): MonitoringHit[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(MonitoringHit, v);
    })
  }
  serialize = (values: MonitoringHit[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class MonitoringAlert {
  @JsonProperty({name: "reference"})
  public reference?: string = undefined;

  @JsonProperty({name: "report"})
  public report?: string = undefined;

  @JsonProperty({name: "info"})
  public info?: string = undefined;

  @JsonProperty({name: "value"})
  public value?: number = undefined;

  @JsonProperty({name: "score"})
  public score?: number = undefined;

  @JsonProperty({name: "result"})
  public result?: number = undefined;

  @JsonProperty({name: "risk"})
  public risk?: string = undefined;

  @JsonProperty({type: MonitoringHit, deserializer: ArrayMonitoringHitSerializerDeserializer, name: "hits"})
  public hits: MonitoringHit[] = [];

  @JsonProperty({type: MonitoringTransaction, deserializer: ArrayMonitoringTransactionSerializerDeserializer, name: "hits"})
  public history: MonitoringTransaction[] = [];
}

export class ScoringHit {
  @JsonProperty({name: "reference"})
  public reference?: string = undefined;

  @JsonProperty({name: "info"})
  public info?: string = undefined;

  @JsonProperty({name: "score"})
  public score?: number = undefined;

}

@CacheKey("ArrayScoringHitSerializerDeserializer")
export class ArrayScoringHitSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): ScoringHit[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(ScoringHit, v);
    })
  }
  serialize = (values: ScoringHit[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class ScoringAlert {
  @JsonProperty({name: "reference"})
  public reference?: string = undefined;

  @JsonProperty({name: "report"})
  public report?: string = undefined;

  @JsonProperty({name: "info"})
  public info?: string = undefined;

  @JsonProperty({name: "value"})
  public value?: number = undefined;

  @JsonProperty({name: "score"})
  public score?: number = undefined;

  @JsonProperty({name: "result"})
  public result?: number = undefined;

  @JsonProperty({name: "risk"})
  public risk?: string = undefined;

  @JsonProperty({type: ScoringHit, deserializer: ArrayScoringHitSerializerDeserializer, name: "hits"})
  public hits: ScoringHit[] = [];

}

export class ScreeningHit {
  @JsonProperty({name: "reference"})
  public reference?: string = undefined;

  @JsonProperty({name: "info"})
  public info?: string = undefined;

  @JsonProperty({name: "list_owner"})
  public listOwner?: string = undefined;

  @JsonProperty({name: "list_vertical"})
  public listVertical?: string = undefined;

  @JsonProperty({name: "list_field"})
  public listField?: string = undefined;

  @JsonProperty({name: "list_data"})
  public listData?: string = undefined;

  @JsonProperty({name: "data_field"})
  public dataField?: string = undefined;

  @JsonProperty({name: "data_candidate"})
  public dataCandidate?: string = undefined;

  @JsonProperty({name: "threshold"})
  public threshold?: number = undefined;

  @JsonProperty({name: "value"})
  public value?: number = undefined;

  @JsonProperty({name: "score"})
  public score?: number = undefined;

  @JsonProperty({name: "result"})
  public result?: number = undefined;

}

@CacheKey("ArrayScreeningHitSerializerDeserializer")
export class ArrayScreeningHitSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): ScreeningHit[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(ScreeningHit, v);
    })
  }
  serialize = (values: ScreeningHit[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class ScreeningAlert {
  @JsonProperty({name: "report"})
  public report?: string = undefined;

  @JsonProperty({name: "reference"})
  public reference?: string = undefined;

  @JsonProperty({name: "info"})
  public info?: string = undefined;

  @JsonProperty({name: "list", type: Channel})
  public list?: Channel = undefined;

  @JsonProperty({name: "data", type: Channel})
  public data?: Channel = undefined;

  @JsonProperty({name: "value"})
  public value?: number = undefined;

  @JsonProperty({name: "score"})
  public score?: number = undefined;

  @JsonProperty({name: "result"})
  public result?: number = undefined;

  @JsonProperty({name: "risk"})
  public risk?: string = undefined;

  @JsonProperty({type: ScreeningHit, deserializer: ArrayScreeningHitSerializerDeserializer, name: "hits"})
  public hits: ScreeningHit[] = [];

}

@CacheKey("OptionScreeningAlertSerializerDeserializer")
export class OptionScreeningAlertSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (value?: Object): ScreeningAlert => {
    if (value) {
      return ObjectMapper.deserialize(ScreeningAlert, value);
    } else {
      return new ScreeningAlert();
    }
  }
  serialize = (value?: ScreeningAlert): Object => {
    return ObjectMapper.serialize(value);
  }
}

@CacheKey("OptionScoringAlertSerializerDeserializer")
export class OptionScoringAlertSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (value?: Object): ScoringAlert => {
    if (value) {
      return ObjectMapper.deserialize(ScoringAlert, value);
    } else {
      return new ScoringAlert();
    }
  }
  serialize = (value?: ScoringAlert): Object => {
    return ObjectMapper.serialize(value);
  }
}

@CacheKey("OptionMonitoringAlertSerializerDeserializer")
export class OptionMonitoringAlertSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (value?: Object): MonitoringAlert => {
    if (value) {
      return ObjectMapper.deserialize(MonitoringAlert, value);
    } else {
      return new MonitoringAlert();
    }
  }
  serialize = (value?: MonitoringAlert): Object => {
    return ObjectMapper.serialize(value);
  }
}

export class RedFlag {
  @JsonProperty({name: "external"})
  public external?: string = undefined;

  @JsonProperty({type: ScreeningAlert, deserializer: OptionScreeningAlertSerializerDeserializer, name: "screening"})
  public screening?: ScreeningAlert = undefined;

  @JsonProperty({type: ScoringAlert, deserializer: OptionScoringAlertSerializerDeserializer, name: "scoring"})
  public scoring?: ScoringAlert = undefined;

  @JsonProperty({type: MonitoringAlert, deserializer: OptionMonitoringAlertSerializerDeserializer, name: "monitoring"})
  public monitoring?: MonitoringAlert = undefined;
}

@CacheKey("ArrayRedFlagSerializerDeserializer")
export class ArrayRedFlagSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): RedFlag[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(RedFlag, v);
    })
  }
  serialize = (values: RedFlag[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class RiskFactor {
  @JsonProperty({name: "batch"})
  public batch?: string = undefined;

  @JsonProperty({name: "channel", type: Channel})
  public channel?: Channel = undefined;

  @JsonProperty({name: "name"})
  public name?: string = undefined;

  @JsonProperty({name: "process"})
  public process?: string = undefined;

  @JsonProperty({name: "data"})
  public data?: string = undefined;

  @JsonProperty({name: "report"})
  public report?: string = undefined;

  @JsonProperty({name: "description"})
  public description?: string = undefined;

  @JsonProperty({name: "info"})
  public info?: string = undefined;

  @JsonProperty({name: "result"})
  public result?: number = undefined;

  @JsonProperty({name: "risk"})
  public risk?: string = undefined;

  @JsonProperty({name: "case"})
  public case?: string = undefined;

  @JsonProperty({type: RedFlag, deserializer: ArrayRedFlagSerializerDeserializer, name: "flags"})
  public flags: RedFlag[] = [];

}

@CacheKey("ArrayRiskFactorSerializerDeserializer")
export class ArrayRiskFactorSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): RiskFactor[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(RiskFactor, v);
    })
  }
  serialize = (values: RiskFactor[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class RiskReason {
  @JsonProperty({name: "reason"})
  public reason?: string = undefined;

  @JsonProperty({name: "risk"})
  public risk?: string = undefined;
}

@CacheKey("ArrayRiskReasonSerializerDeserializer")
export class ArrayRiskReasonSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): RiskReason[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(RiskReason, v);
    })
  }
  serialize = (values: RiskReason[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class ResultCase {
  @JsonProperty({name: "internal"})
  public internal?: string = undefined;

  @JsonProperty({name: "batch"})
  public batch?: string = undefined;

  @JsonProperty({name: "channel", type: Channel})
  public channel?: Channel = undefined;

  @JsonProperty({name: "entry", type: DataEntry})
  public entry?: DataEntry = undefined;

  @JsonProperty({name: "data"})
  public data?: string = undefined;

  @JsonProperty({name: "record"})
  public record?: string = undefined;

  @JsonProperty({name: "process"})
  public process?: string = undefined;

  @JsonProperty({name: "entity"})
  public entity?: string = undefined;

  @JsonProperty({name: "report"})
  public report?: string = undefined;

  @JsonProperty({name: "info"})
  public info?: string = undefined;

  @JsonProperty({name: "created"})
  public created?: number = undefined;

  @JsonProperty({name: "result"})
  public result?: number = undefined;

  @JsonProperty({name: "risk"})
  public risk?: string = undefined;

  @JsonProperty({name: "external"})
  public external?: string = undefined;

  @JsonProperty({type: RiskFactor, deserializer: ArrayRiskFactorSerializerDeserializer, name: "factors"})
  public factors: RiskFactor[] = [];

  @JsonProperty({type: RiskReason, deserializer: ArrayRiskReasonSerializerDeserializer, name: "reasons"})
  public reasons: RiskReason[] = [];

  @JsonProperty({name: "status"})
  public status?: string = undefined;
}
